import { api } from "@/lib/api";
import type { Session } from "@/types/admin";

export interface SessionsListResponse {
	data: Session[];
	meta: {
		page: number;
		limit: number;
		total: number;
		totalPages: number;
		hasNext: boolean;
		hasPrev: boolean;
	};
}

export interface SessionsFilters {
	page?: number;
	limit?: number;
	userId?: string;
	status?: "active" | "revoked";
	search?: string;
}

// Sessions API Service
export const sessionsService = {
	// Get paginated list of sessions
	getSessions: async (
		page = 1,
		limit = 50,
		filters?: Omit<SessionsFilters, "page" | "limit">,
	): Promise<SessionsListResponse> => {
		const params = {
			page,
			limit,
			...filters,
		};

		const response = await api.get<SessionsListResponse>(
			"/admin/sessions",
			params,
		);
		if (!response.data.success || !response.data.data) {
			throw new Error("Failed to fetch sessions");
		}
		return response.data.data;
	},

	// Revoke session
	revokeSession: async (sessionId: string): Promise<Session> => {
		const response = await api.post<Session>(
			`/admin/sessions/${sessionId}/revoke`,
		);
		if (!response.data.success || !response.data.data) {
			throw new Error("Failed to revoke session");
		}
		return response.data.data as Session;
	},
};
